import {useGetUsersQuery} from "../store/userApi/userApiSlice.ts";
import {useEffect, useState} from "react";
import {
    Box,
    Spinner,
    Table,
    TableContainer,
    Tag,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue
} from "@chakra-ui/react";
import type {user} from "../utils/typesConstant/types.tsx";
import AddUserModal from "../components/modals/AddUserModal.tsx";
import UserHeader from "../components/userComponent/UserHeader.tsx";
import {useSelector} from "react-redux";
import {RootState} from "../store/store.ts";

function UserListing() {
    let {isSuccess, data, isLoading} = useGetUsersQuery();
    const [openModal, setOpenModal] = useState(false);
    const [selectedUserDetail, setSelectedUserDetail] = useState<user>({
        date_joined: "",
        email: "",
        first_name: "",
        groups: [],
        id: 0,
        is_active: false,
        is_staff: false,
        is_superuser: false,
        last_login: undefined,
        last_name: "",
        password: "",
        user_permissions: [],
        username: ""
    });
    const bgColor = useColorModeValue("white", "gray.700");

    let doctors = data?.users
    const searchValue = useSelector((state: RootState) => state?.search?.value)
    if (searchValue.trim()) {
        doctors = doctors?.filter(doctor =>
            doctor.first_name.toLowerCase().includes(searchValue.toLowerCase()) ||
            doctor.last_name.toLowerCase().includes(searchValue.toLowerCase()) ||
            doctor.email.includes(searchValue)
        )
    }
    useEffect(() => {
        console.log("data of user details are :: ", data);
    }, [data]);

    const renderStatusTag = (isActive: boolean) => (
        <Tag
            variant="subtle"
            colorScheme={isActive ? "green" : "gray"}
            fontWeight="medium"
        >
            {isActive ? "Active" : "Discharged"}
        </Tag>
    );

    const subTextColor = useColorModeValue("gray.500", "white");

    const user = useSelector((state: RootState) => state?.user?.user)

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                <Spinner size="xl" color="blue"/>
            </Box>
        );
    }

    if (doctors?.length === 0)
        return 'Sorry we could not find any results'

    if (!user?.isSuperuser) {
        return 'You dont have access to this page.';
    }

    return (
        <Box p={4}>
            <Box position="fixed" top="100px" left="320" right="8" bg="#F4F7FE">
                <UserHeader open={openModal} setOpen={setOpenModal}/>
            </Box>
            {openModal && (
                <AddUserModal
                    open={openModal}
                    setOpen={setOpenModal}
                    userDetails={selectedUserDetail}
                    setUserDetails={setSelectedUserDetail}
                />
            )}

            <TableContainer borderRadius="lg" boxShadow="sm" bg={bgColor} mt={14}>
                <Table variant="simple">
                    <Thead>
                        <Tr>
                            <Th fontWeight="bold" color={subTextColor}>NAME</Th>
                            <Th fontWeight="bold" color={subTextColor}>SUPERUSER</Th>
                            <Th fontWeight="bold" color={subTextColor}>EMAIL</Th>
                            <Th fontWeight="bold" color={subTextColor}>JOINED</Th>
                            <Th fontWeight="bold" color={subTextColor}>LAST LOGIN</Th>
                            <Th fontWeight="bold" color={subTextColor}>STATUS</Th>
                            <Th fontWeight="bold" color={subTextColor}>ACTIONS</Th>
                        </Tr>
                    </Thead>

                    <Tbody>
                        {isSuccess && doctors?.map((user) => (
                            <Tr key={user.id} onClick={() => {
                                setSelectedUserDetail(user);
                                setOpenModal(true);
                            }}>
                                <Td>
                                    <Box display="flex" alignItems="center" gap={3}>
                                        {/*<Avatar bg="teal.50" color="teal.600" fontWeight="bold" size="sm">*/}
                                        {/*    {getInitials(user.first_name, user.last_name)}*/}
                                        {/*</Avatar>*/}
                                        <Text fontWeight="semibold" fontSize="14px">
                                            {user.first_name} {user.last_name}
                                        </Text>
                                    </Box>
                                </Td>
                                <Td fontWeight="semibold" fontSize="14px">{user.is_superuser ? "Yes" : "No"}</Td>
                                <Td fontWeight="semibold" fontSize="14px">{user.email}</Td>
                                <Td fontWeight="semibold" fontSize="14px">
                                    {new Date(user.date_joined).toLocaleDateString()}
                                </Td>
                                <Td fontWeight="semibold" fontSize="14px">
                                    {new Date(user.last_login).toLocaleDateString()}
                                </Td>
                                <Td>{renderStatusTag(user.is_active)}</Td>
                                <Td>
                                    <Text
                                        color="#422AFB"
                                        fontWeight="semibold"
                                        cursor="pointer"
                                    >
                                        Edit
                                    </Text>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default UserListing;
